var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeaderIcon05(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.01494 2.68262C6.53244 2.68262 4.51494 4.70012 4.51494 7.18262V9.35012C4.51494 9.80762 4.31994 10.5051 4.08744 10.8951L3.22494 12.3276C2.69244 13.2126 3.05994 14.1951 4.03494 14.5251C7.26744 15.6051 10.7549 15.6051 13.9874 14.5251C14.8949 14.2251 15.2924 13.1526 14.7974 12.3276L13.9349 10.8951C13.7099 10.5051 13.5149 9.80762 13.5149 9.35012V7.18262C13.5149 4.70762 11.4899 2.68262 9.01494 2.68262Z",
    stroke: "#2C323F",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4024 2.90008C10.1699 2.83258 9.92994 2.78008 9.68244 2.75008C8.96244 2.66008 8.27244 2.71258 7.62744 2.90008C7.84494 2.34508 8.38494 1.95508 9.01494 1.95508C9.64494 1.95508 10.1849 2.34508 10.4024 2.90008Z",
    stroke: "#2C323F",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2651 14.7949C11.2651 16.0324 10.2526 17.0449 9.01514 17.0449C8.40014 17.0449 7.83014 16.7899 7.42514 16.3849C7.02014 15.9799 6.76514 15.4099 6.76514 14.7949",
    stroke: "#2C323F",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderIcon05);
export default __webpack_public_path__ + "static/media/header-icon-05.3882992ba56b46255f5929a88568b357.svg";
export { ForwardRef as ReactComponent };